// import React from 'react';
// import { Box, IconButton, Tooltip } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import LogoutIcon from '@mui/icons-material/Logout'; // Logout icon import kara
// import { useNavigate } from 'react-router-dom'; // Navigate sathi

// const Topbar = ({ toggleSubSidebar }) => {
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     // Ithe tuze logout logic (session clear karne) lihu shakto
//     navigate('/'); // Login page var pathva
//   };

//   return (
//     <Box sx={{ 
//       width: '100%', 
//       height: '65px', 
//       display: 'flex', 
//       alignItems: 'center', 
//       bgcolor: '#ffffff', 
//       px: 3, 
//       boxSizing: 'border-box',
//       boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)', 
//       zIndex: 1100,
//       position: 'relative'
//     }}>
//       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>

//         {/* Left Side: Menu Icon */}
//         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//           <IconButton 
//             onClick={toggleSubSidebar}
//             sx={{ 
//               bgcolor: '#f8fafc', 
//               borderRadius: '10px', 
//               p: 1,
//               '&:hover': { bgcolor: '#f1f5f9' } 
//             }}
//           >
//             <MenuIcon sx={{ color: '#1e293b', fontSize: 22 }} />
//           </IconButton>
//         </Box>

//         {/* Center: Red Progress Line */}
//         <Box sx={{ 
//           flexGrow: 1, 
//           mx: 6, 
//           height: '4px', 
//           bgcolor: '#ff0000', 
//           borderRadius: '10px'
//         }} />

//         {/* Right Side: Logout Icon (Logo ऐवजी प्रोफेशनल Logout Button) */}
//         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//           <Tooltip title="Logout">
//             <IconButton 
//               onClick={handleLogout}
//               sx={{ 
//                 bgcolor: '#fff5f5', 
//                 color: '#d32f2f', 
//                 border: '1px solid #ffebee',
//                 borderRadius: '10px',
//                 p: 1.2,
//                 '&:hover': { bgcolor: '#ffebee' } 
//               }}
//             >
//               <LogoutIcon sx={{ fontSize: 22 }} />
//             </IconButton>
//           </Tooltip>
//         </Box>

//       </Box>
//     </Box>
//   );
// };

// export default Topbar;

import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Menu, MenuItem, Typography, Badge, ListItemButton } from '@mui/material';
import { keyframes, styled } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router-dom';

const Topbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    // Session clear logic ithe lihu shakto
    navigate('/');
  };

  const wave = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); } // वर जाणे
`;

  const AnimatedText = styled('span')(({ index }) => ({
    display: 'inline-block',
    background: 'linear-gradient(45deg, #120346, #1a237e)', // ऑरेंज + ब्लू ग्रेडियंट
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 900,
    fontSize: '1.2rem',
    // प्रत्येक अक्षराला थोडा उशीर (Delay) दिला आहे ज्यामुळे 'Wave' इफेक्ट येईल
    animation: `${wave} 4s ease-in-out infinite`,
    animationDelay: `${index * 0.15}s`,
  }));

  return (
    <Box sx={{
      width: '100%', height: '65px', display: 'flex', alignItems: 'center',
      bgcolor: 'rgba(255, 255, 255, 0.9)', backdropFilter: 'blur(10px)',
      px: 3, boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.05)',
      position: 'sticky', top: 0, zIndex: 1100
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>

        {/* 1. Left Section: Sidebar Toggle & Page Title */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton onClick={toggleSidebar} sx={{ bgcolor: '#f8fafc', borderRadius: '10px' }}>
            <MenuIcon sx={{ color: '#1e293b' }} />
          </IconButton>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              display: { xs: 'none', md: 'block' },
              letterSpacing: 1
            }}
          >
            {"Varadvinayak CRM".split("").map((char, index) => (
              <AnimatedText key={index} index={index}>
                {char === " " ? "\u00A0" : char} {/* स्पेससाठी खास कोड */}
              </AnimatedText>
            ))}
          </Typography>
        </Box>

        {/* 2. Center: Professional Progress Line */}
        <Box sx={{ flexGrow: 1, mx: 6, height: '3px', bgcolor: '#f1f5f9', borderRadius: '10px', position: 'relative' }}>
          <Box sx={{ width: '40%', height: '100%', bgcolor: '#ff0000', borderRadius: '10px' }} /> {/* Static example */}
        </Box>

        {/* 3. Right Section: Notifications & Profile */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title="Logout" placement="right">
            <ListItemButton
              onClick={handleLogout}
              sx={{
                borderRadius: '50%', width: 50, height: 50,
                justifyContent: 'center',
                color: '#d32f2f', // Red color for logout
                bgcolor: '#fff5f5',
                '&:hover': { bgcolor: '#ffebee' }
              }}>
              <LogoutIcon />
            </ListItemButton>
          </Tooltip>

          <IconButton onClick={handleMenu}>
            {/* <AccountCircleIcon sx={{ color: '#1a237e', fontSize: 32 }} /> */}
          </IconButton>

          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} sx={{ mt: 1 }}>
            <MenuItem onClick={handleClose}>My Profile</MenuItem>
            <MenuItem onClick={() => navigate('/')} sx={{ color: 'red' }}>
              <LogoutIcon sx={{ fontSize: 18, mr: 1 }} /> Logout
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </Box>
  );
};

export default Topbar;